import { useMemo } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseScoreCardProvider } from 'components/widgets/ProjectSummary/ProjectSummary.provider';

interface Props {
    api: UseScoreCardProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
    ui: UseScoreCardProvider['ui'];
}

export const useProjectSummaryLogic = ({ api, setIsPayloadReady, widgetViewMode, ui }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getProjectStatusScoreCards.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    const showLoader = ui.vars.networkStatus === 'idle' || ui.vars.networkStatus === 'loading';

    const showData = !showLoader && Boolean(ui.vars.data);

    const showEmpty = !showLoader && !ui.vars.data;

    const tooltipInfo = ui.vars.data?.info;

    const qualityCardData = useMemo(
        () => ui.vars.data?.summaryCards.find((card) => card?.cardTitle.cardType === 'QualityCard'),
        [ui.vars.data],
    );
    const progressCardData = useMemo(
        () => ui.vars.data?.summaryCards.find((card) => card?.cardTitle.cardType === 'ProgressCard'),
        [ui.vars.data],
    );

    const riskCardData = useMemo(
        () => ui.vars.data?.summaryCards.find((card) => card?.cardTitle.cardType === 'RiskCard'),
        [ui.vars.data],
    );

    const showNoData =
        !riskCardData?.cardProperties && !qualityCardData?.cardProperties && !progressCardData?.cardProperties;

    return {
        logic: {
            qualityCardData,
            progressCardData,
            riskCardData,
            showNoData,
            showLoader,
            showData,
            showEmpty,
            tooltipInfo,
        },
    };
};
